import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { CreatePage } from 'pages/clients/pages/create'
import { CreateLayout } from 'pages/clients/pages/create/layout/CreateLayout'

export const CreateRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<CreateLayout />}>
        <Route path={'/'} element={<CreatePage />} />
      </Route>
    </RoutesWithNotFound>
  )
}
